import { render } from "./AgentManagement.vue?vue&type=template&id=00a36b89&scoped=true"
import script from "./AgentManagement.vue?vue&type=script&lang=js"
export * from "./AgentManagement.vue?vue&type=script&lang=js"

import "./AgentManagement.vue?vue&type=style&index=0&id=00a36b89&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a36b89"]])

export default __exports__